import { SxProps, Theme } from '@mui/material/styles';

export const titleCategorySX: SxProps<Theme> = {
	fontWeight: {
		xs: '600',
		sm: '600',
	},
	fontSize: {
		xs: 'var(--font-size-small)',
		sm: 'var(--font-size-md)',
	},
	textAlign: {
		xs: 'center',
		sm: 'center',
	},
	color: 'text.primary',
	mt: '10px',
	px: '10px',
	letterSpacing: '0px',
};
